var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.43041 22.977V12.6753H6.75V8.96619H9.43041V5.79812C9.43041 3.30863 11.0137 1.02246 14.6621 1.02246C16.1392 1.02246 17.2315 1.16637 17.2315 1.16637L17.1454 4.63005C17.1454 4.63005 16.0315 4.61903 14.8159 4.61903C13.5002 4.61903 13.2894 5.23519 13.2894 6.25785V8.96619H17.25L17.0777 12.6753H13.2894V22.977H9.43041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebookIcon.23232c3d04e31577cd75e3d6a71e24b0.svg";
export { ForwardRef as ReactComponent };